"use strict";

module.exports = {
  /*<editor-fold desc="[ RA settings ]">*/
  RA_SETTING_BOOKPACK: "ra:bookPack",
  IC_SETTING_ORGANISATION_QUESTIONNAIRE: "ic:organisationQuestionnaire",
  BAP_SETTING_ORGANISATION_FRAMEWORK: "2bap:organisationFrameworks",
  CORE_SETTING_MODULES: "core:modules",
  /*</editor-fold desc="[ RA settings ]">*/
};

